import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { isBlockedLimitReached } from "../../../store/devices/logicalDevices";
import { Icon } from "../../icon/Icon";
import { openBlockModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

/**
 * @param {*} device { identifiers: [identifier], type, manufacturer }
 */
export const useBlockDeviceMenuItem = (device) => {
  const dispatch = useDispatch();
  const isBlockDisabled = useSelector(isBlockedLimitReached);

  return {
    id: "block",
    content: (
      <Fragment>
        <Icon icon="fa-solid fa-ban" />
        <span>
          <FormattedMessage id="block" />
        </span>
      </Fragment>
    ),
    disabled: isBlockDisabled,
    action: () => dispatch(openBlockModal(device)),
  };
};

export const BlockDeviceDropdownItem = ({ device, ...props }) => {
  const { id, content, disabled, action } = useBlockDeviceMenuItem(device);

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const BlockDeviceModalItem = ({ device }) => {
  const { id, content, disabled, action } = useBlockDeviceMenuItem(device);

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
